/*
import skySoft from "../images/sky-soft.jpg";
import ee from "../images/ee.jpg";

export default function Hero() {
  return (
    <section
      id="inicio"
      style={{
        backgroundImage: `url(${skySoft})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="py-20 md:py-28 flex flex-col justify-center"
    >
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
        {}
        <div className="text-center md:text-left">
          <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-4 drop-shadow-sm">
            Arriendo parcela Los Molles
          </h1>

          <p className="text-gray-700 max-w-2xl md:max-w-lg mx-auto md:mx-0 mb-8">
            Parcela con amplia casa de madera y gran pérgola, sector Santa María de Los Molles.
            Casa aislada, cuenta con tres amplias habitaciones para hospedar a 8 personas de manera
            confortable.
            Baño completo con ducha de agua caliente y lavadora.
            La casa cuenta con un living, comedor, mueble de libros, estufa a leña todo en un amplio
            pasillo.
            La pérgola tiene un comedor de diario, living, cocina, decodificador con señal de internet
            inalámbrica (WIFI) para señal de TV satelital.
            Todo esto se encuentra en un terreno de 5.000 metros cuadrados.
            Espacio para asado con parrilla.
            Somos amigables con el medio ambiente por lo que se les pide utilizar los contenedores de
            reciclaje y basurero.
          </p>

          <div className="flex gap-4 justify-center md:justify-start">
            <a
              href="#contacto"
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl shadow transition"
            >
              Agendar arriendo
            </a>
            <a
              href="#servicios"
              className="border border-blue-600 text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-xl transition"
            >
              Ver actividades
            </a>
          </div>
        </div>

        {}
        <div className="hidden md:block">
          <div
            style={{
              backgroundImage: `url(${ee})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
            className="h-[340px] md:h-[400px] rounded-2xl shadow-lg"
            aria-label="Imagen terapéutica"
          />
        </div>
      </div>
    </section>
  );
}
*/

import skySoft from "../images/sky-soft.jpg";
import ee from "../images/ee.jpg";

export default function Hero() {
  return (
    <section
      id="inicio"
      style={{
        backgroundImage: `url(${skySoft})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      className="py-20 md:py-28 flex flex-col justify-center"
    >
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">

        {/* 🔵 Columna izquierda: imagen (ANTES era texto) */}
        <div className="hidden md:block">
          <div
            style={{
              backgroundImage: `url(${ee})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
            className="h-[340px] md:h-[400px] rounded-2xl shadow-lg"
            aria-label="Imagen de la parcela"
          />
        </div>

        {/* 🟢 Columna derecha: texto (ANTES era imagen) */}
        <div className="text-center md:text-left">
          <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-4 drop-shadow-sm">
            Arriendo parcela Los Molles
          </h1>

          <p className="text-gray-700 max-w-2xl md:max-w-lg mx-auto md:mx-0 mb-8">
            Parcela con amplia casa de madera y gran pérgola, sector Santa María de Los Molles.
            Casa aislada, cuenta con tres amplias habitaciones para hospedar a 8 personas de manera
            confortable.
            Baño completo con ducha de agua caliente y lavadora.
            La casa cuenta con un living, comedor, mueble de libros, estufa a leña todo en un amplio
            pasillo.
            La pérgola tiene un comedor de diario, living, cocina, decodificador con señal de internet
            inalámbrica (WIFI) para señal de TV satelital.
            Todo esto se encuentra en un terreno de 5.000 metros cuadrados.
            Espacio para asado con parrilla.
            Somos amigables con el medio ambiente por lo que se les pide utilizar los contenedores de
            reciclaje y basurero.
          </p>

          <div className="flex gap-4 justify-center md:justify-start">
            <a
              href="#contacto"
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl shadow transition"
            >
              Agendar arriendo
            </a>
            <a
              href="#servicios"
              className="border border-blue-600 text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-xl transition"
            >
              Ver actividades
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}

